import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "../../components/States/AppContext";

//styles
import {
  Footnote,
  PowerOnBox,
  PowerOnLogo,
  PowerOnLogoContainer,
  PowerOnText,
  ProgressBar,
  ProgressBarContainer,
} from "./PowerOn.elements";

//images
import logo from "../../img/misc/logo2.png";



const PowerOn = () => {
  const { state, setState } = useContext(AppContext);
  const [progress, setProgress] = useState(0);



  function handleClick() {

    setState((prevState) => ({
      ...prevState,
      init: false,
      reboot: true,
      telemetry: false,
      piicConnected: false,
    }));
  }

  return (
    <>
      <PowerOnBox>
        <PowerOnLogoContainer>
          <PowerOnLogo src={logo} />
        </PowerOnLogoContainer>

        <PowerOnText>Philips</PowerOnText>
        <PowerOnText>Telemetry Monitor 5500</PowerOnText>

        <ProgressBarContainer>
          <ProgressBar progress={progress} onAnimationEnd={handleClick} />
        </ProgressBarContainer>
      </PowerOnBox>

      <Footnote>*Simulated Power Up Time</Footnote>
    </>
  );
};

export default PowerOn;
